export default __webpack_public_path__ + "_/shared/assets/images/logo/equinet_logo.png";